import { render } from "./MerchantDetail.vue?vue&type=template&id=70109dd0&scoped=true"
import script from "./MerchantDetail.vue?vue&type=script&lang=js"
export * from "./MerchantDetail.vue?vue&type=script&lang=js"

import "./MerchantDetail.vue?vue&type=style&index=0&id=70109dd0&scoped=true&lang=css"

import exportComponent from "/var/www/html/minty.crm.frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70109dd0"]])

export default __exports__